module.exports = __webpack_public_path__ + "img/main_menu_hover_3.6ea787d4.png";